<template>
  <el-dialog title="交易流水明细" :visible.sync="dialogFormVisible" width="500px" center top="10vh" :close-on-click-modal="false" @close="closeDialog">
    <div class="waterdetailwrap">
      <div class="head">
        <div><span>币种：</span><span>{{pathRow.currType}}</span></div>
        <div><span>交易流水号：</span><span>{{pathRow.serialNo}}</span></div>
      </div>
      <div class="content">
        <div class="item">
          <div class="left">对方账号</div>
          <div class="right">{{pathRow.recipAcc}}</div>
        </div>
        <div class="item">
          <div class="left">对方账户名</div>
          <div class="right">{{pathRow.recipName}}</div>
        </div>
        <div class="item">
          <div class="left">对方行号</div>
          <div class="right">{{pathRow.recipNo}}</div>
        </div>
        <div class="item">
          <div class="left">对方行名</div>
          <div class="right">{{pathRow.recipbkName}}</div>
        </div>
        <div class="line"></div>
        <div class="item">
          <div class="left">交易金额</div>
          <div class="right">{{pathRow.amount}}</div>
        </div>
        <div class="item">
          <div class="left">当前余额</div>
          <div class="right">{{pathRow.balance}}</div>
        </div>
        <div class="line"></div>
        <div class="item">
          <div class="left">用途</div>
          <div class="right">{{pathRow.purpose}}</div>
        </div>
        <div class="line"></div>
        <div class="item">
          <div class="left">凭证号</div>
          <div class="right">{{pathRow.vouhNo}}</div>
        </div>
        <div class="item">
          <div class="left">渠道</div>
          <div class="right">{{pathRow.channel}}</div>
        </div>
        <div class="item">
          <div class="left">交易代码</div>
          <div class="right">{{pathRow.transcode}}</div>
        </div>
        <div class="item">
          <div class="left">交易时间</div>
          <div class="right">{{$util.formatDate.format(pathRow.transTime,'yyyy-MM-dd hh:mm:ss')}}</div>
        </div>
        <div class="line"></div>
        <div class="item">
          <div class="left">附言</div>
          <div class="right">{{pathRow.postScripa}}</div>
        </div>
        <div class="item">
          <div class="left">摘要</div>
          <div class="right">{{pathRow.summary}}</div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" align="center">
      <el-button style="width: 120px;background: #269D7B;border: none;" size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['visible','row'],
  	data(){
  		return {
        loading:false,
        dialogFormVisible:false,
        list:'',
        pathRow:{},
        ruleForm:{
          region:'',
          name:''
        }
  		}
  	},

  	computed: {

  	},
  	methods:{
      closeDialog(){
        this.dialogFormVisible=false
        this.$emit('refresh',false)
      },
  	},
    watch: {
  　　visible: {
　　　　handler(newValue, oldValue) {
          if(newValue.showdialog){
            this.dialogFormVisible=true
            this.pathRow=newValue.row
            newValue.moneyTypeList.forEach((item)=>{
              if(newValue.row.currType==item.value){
                this.pathRow.currType=item.label
              }
            })
          }
　　　　},
　　　　deep: true,
       immediate: true
  　　},

    }
  }
</script>

<style lang="less" scoped>
  .waterdetailwrap{
    .head{
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }
    .content{
      margin-top: 20px;
      border: 1px dashed #DCDCDC;
      box-sizing: border-box;
      padding: 30px;
      font-size: 14px;
      .line{
        height: 2px;
        border-bottom: 1px dashed #DCDCDC;
        width: 100%;
        margin-bottom: 15px;
      }
      .item{
        display: flex;
        margin-bottom: 15px;
        .left{
          width: 75px;
          padding-right: 20px;
          text-align: right;
          color: #4A4A4A;
          font-weight:400;
        }
        .right{
          flex:1;
          color: #333333;
          font-weight:500;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bankwater/waterDetail.vue